import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from './IconUtils';

export const EmailIcon = ({ id, size = 'small', onClick, disabled, dataAttributes }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.EmailAt}
      alt="img"
      className={cn(styles.icon, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      {...dataAttributes}
    />
  );
};
